<template>
  <div class="home-content">
    <Tabs v-model="active" type="card" color="#aa341b" @click="changeTab">
      <Tab title="拜访" />
      <Tab title="协访" />
    </Tabs>
    <div style="height: 20px"></div>
    <div
      ref="scrollContainer"
      style="height: calc(100vh - 120px); overflow-y: scroll"
      @scroll="handleScroll"
    >
      <Loading
        v-if="loading"
        style="margin-bottom: 40px"
        type="spinner"
        color="#aa341b"
      />
      <div
        v-if="false && finished"
        style="
          text-align: center;
          color: #969799;
          font-size: 14px;
          padding: 10px 0 30px 0;
        "
      >
        没有更多了
      </div>
      <div v-for="(item, index) in lastList" :key="index">
        <div class="date-title">{{ item.time }}</div>
        <div>
          <VisitListItem
            v-for="(sonItem, sonIndex) in item.list"
            :key="sonIndex"
            :color="changeColor(item.time)"
            :item="sonItem"
          />
        </div>
      </div>
      <Empty
        v-if="!lastList.length && !loading"
        description="无数据"
        image="/image/empty.png"
      />
    </div>

    <Button
      class="floating"
      round
      type="info"
      icon="plus"
      color="#aa341b"
      @click="
        active === 1
          ? $router.push(`visit-create?isCoVisit=${active}`)
          : $router.push(`visit-create`)
      "
    >
      新建{{ ['拜访', '协访'][active] }}
    </Button>
    <div style="height: 50px"></div>
  </div>
</template>
<script>
import VisitListItem from './components/visitListItem.vue';
import {Button, Tabs, Tab, Empty, Loading} from 'vant';
import {fetchPhysicianMslCalls} from '@/api/kol';
import {
  getFirstUpperChar,
  getLocalStorage,
  setLocalStorage,
  debounce,
} from '@/utils/index';

export default {
  components: {
    VisitListItem,
    Button,
    Tabs,
    Tab,
    Empty,
    Loading,
  },
  data() {
    return {
      active: '0',
      lastList: [],
      lastScrollHeight: 0,
      loading: false,
      finished: false,
      pageSize: 30,
      currentPage: 0,
    };
  },
  created() {
    this.getPhysicianMsICalls();
  },
  mounted() {},
  destroyed() {},
  methods: {
    getLocalStorage,
    async getPhysicianMsICalls() {
      if (this.finished || this.loading) return;

      this.loading = true;

      const res = await fetchPhysicianMslCalls(
        {
          is_co_call: Number(this.active),
          call_msl_user_id: getLocalStorage('user_id'),
        },
        this.currentPage * this.pageSize,
        this.pageSize,
      );

      if (!res.value || res.value.length < this.pageSize) {
        this.finished = true;
      }
      const changeArr = this.convertTo2DArray(res.value);
      this.lastList = [...changeArr, ...this.lastList];

      if (this.currentPage === 0) {
        this.$nextTick(() => {
          const container = this.$refs.scrollContainer;
          container.scrollTop = container.scrollHeight;

          this.currentPage++;
          this.loading = false;
        });
      } else {
        setTimeout(() => {
          const container = this.$refs.scrollContainer;
          const {scrollHeight, clientHeight} = container;
          container.scrollTop = scrollHeight - clientHeight - this.lastScrollHeight;
          container.scrollTo({
            top: scrollHeight - clientHeight - this.lastScrollHeight,
            behavior: 'auto',
          });

          this.currentPage++;
          this.loading = false;
        }, 10);
      }
    },
    convertTo2DArray(inputArray) {
      const dateMap = {};

      for (let i = inputArray.length - 1; i >= 0; i--) {
        const element = inputArray[i];
        const callTime = element.call_time.split('T')[0]; // 截取日期部分
        const currentDate = new Date().toISOString().split('T')[0]; // 当前日期
        const nextDate = new Date(Date.now() + 24 * 60 * 60 * 1000)
          .toISOString()
          .split('T')[0]; // 明天的日期

        let time;
        if (callTime !== currentDate && callTime !== nextDate) {
          time = new Date(callTime).toLocaleDateString('zh-CN', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          }); // 格式化日期为 "YYYY年MM月DD日"
        }
        if (callTime === currentDate) {
          time = '今天';
        }
        if (callTime === nextDate) {
          time = '明天';
        }

        if (Object.prototype.hasOwnProperty.call(dateMap, time)) {
          dateMap[time].list.push(element);
        } else {
          dateMap[time] = {time, list: [element]};
        }
      }

      const resultArray = Object.values(dateMap);
      return resultArray;
    },
    changeTab() {
      this.lastList = [];
      this.currentPage = 0;
      this.finished = false;
      this.getPhysicianMsICalls();
    },
    changeColor(e) {
      if (e === '今天') {
        return '#aa341b';
      } else if (e === '明天') {
        return '#f5b496';
      } else {
        return '#B2B2B2';
      }
    },
    handleScroll() {
      const scrollContainer = this.$refs.scrollContainer;
      const {scrollHeight, scrollTop, clientHeight} = scrollContainer;
      if (scrollTop === 0) {
        this.lastScrollHeight = scrollHeight;
        this.getPhysicianMsICalls();
      }
    },
  },
};
</script>
<style scoped lang="scss">
.home-content {
  min-height: calc(100% - 20px);
  padding: 10px;

  .date-title {
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    margin-bottom: 10px;
  }

  .floating {
    position: absolute;
    bottom: 90px;
    right: 10px;
  }

  ::v-deep .van-tabs__nav--card {
    margin: 0;
  }

  ::v-deep .van-tabs__nav {
    border-radius: 50px;
    overflow: hidden;
  }
}
</style>
